import { render, staticRenderFns } from "./IntegrationAffairs.vue?vue&type=template&id=1558effd&scoped=true&"
import script from "./IntegrationAffairs.vue?vue&type=script&lang=js&"
export * from "./IntegrationAffairs.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationAffairs.vue?vue&type=style&index=0&id=1558effd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1558effd",
  null
  
)

export default component.exports